import { Auth } from "@definitions/auth";

export const decodeJWT = (token: string) => {
  try {
    const [_header, payload, _signature] = token.split(".");
    const decodedPayload = atob(payload);

    return JSON.parse(decodedPayload);
  } catch {
    return {};
  }
}

export const isSignedIn = (auth:Auth):boolean => {
  return !!auth.token && !!auth.expiryTime && auth.expiryTime > Date.now();
}